export enum CalendarAction {
  PREV,
  NEXT,
  TODAY,
  DAYS,
  WORK_WEEKS,
  EVENT,
  ZOOM_IN_H,
  ZOOM_OUT_H,
  ZOOM_IN_W,
  ZOOM_OUT_W,
  TOGGLE_FILTER,
  TOGGLE_BASKET,
  INTERVENTION,
  EXCEPTIONAL_CLOSING,
  UNAVAILABILITY,
}
